import psl_templates from './libs/psl_templates.js';

const base_url = import.meta.env.BASE_URL || './';

const _data = {
	inactivity_timeout:5*60*1000,
	//backend_base_url:`${base_url}app_data/`,
	backend_base_url:'https://ama-api.ambientnet.com/data/ama_map_web/',
	gtm_id:'GTM-K83FLB'
};

const helper = (name)=>{
	return _data[name]||"";
};

psl_templates.helpers.add('CONFIG',helper);

export default _data;
